/**
 * Internal symbols used to connect replay thematic controllers to the facade.
 */

export const JOURNEY_REPLAY_INTERNAL_STATE = Symbol('journey-replay-internal-state')
export const JOURNEY_REPLAY_INTERNAL_CALL = Symbol('journey-replay-internal-call')
